import { useMemo, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import './Leaderboard.scss';
import PropTypes from 'prop-types';
import { dayjs } from '@mdc/services';
import { useTranslation } from 'react-i18next';
import LeaderboardTable from './LeaderboardTable';
import DatesDropdown from './DatesDropdown';
import { QueryParams } from '@mdc/services';

const Leaderboard = ({ availableDates, leaderboard, updateDate, title, description, color }) => {
    const { date } = QueryParams();
    const queryDate = date ? date : 'Latest';
    const { i18n, t, ready } = useTranslation();
    const currentLanguage = `&lang=${i18n.language.split('-')[0]}`;

    const currentDate = useMemo(() => {
        const isJpFormatDate = dayjs.locale(i18n.language)==='en'? dayjs().format('MMMM YYYY') : dayjs().format('YYYY MMMM');
        if (date && date.toLowerCase() !== 'latest') {
            return dayjs(date).format('MMMM YYYY');
        }
        return isJpFormatDate;

    }, [QueryParams(), i18n.language]);

    useEffect(() => {
        window.history.replaceState('', '', `?date=${typeof date !== 'undefined' && date.toLowerCase() !== 'latest' ? date : 'Latest'}${currentLanguage}`);
    }, []);

    if (!ready) {
        return null;
    }

    return (
        <div className = "topVoters">
            <Row>
                <Col>
                    <div className = "titleText">
                        <i className = "icon-user-check userIcon"/>
                        <h1>{t(title)}</h1>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} sm={10} md={10}>
                    <div className= "leaderboardText">
                        {currentDate}  {t(description)}
                    </div>
                </Col>
                <Col xs={12} sm={2} md={2}>
                    <span className = "dateGroup">
                        <DatesDropdown
                            queryDate={queryDate}
                            availableDates={availableDates}
                            updateDate={updateDate}
                        />
                    </span>
                </Col>
            </Row>
            <Row>
                <Col>
                    <LeaderboardTable
                        leaderboard={leaderboard}
                        color={color}
                    />
                </Col>
            </Row>
        </div>
    );
};

Leaderboard.propTypes = {
    availableDates: PropTypes.array.isRequired,
    leaderboard: PropTypes.array.isRequired,
    updateDate: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired
};

export default Leaderboard;
